<ng-container
    *ngIf="{
        item: cart$ | async,
        numberAndStats: dataStream$ | async
    } as data">
    <ng-container *ngIf="data.item && data.numberAndStats; else skeleton">
        <div class="purchase-details">
            <div class="steps-content">
                <div
                    nz-row
                    nzGutter="30"
                    class="purchase__row">
                    <div
                        nz-col
                        nzXs="12"
                        class="purchase__info">
                        <div
                            class="purchase__heading"
                            [innerHTML]="wts.getI18nLabel(i18nBasePath, 'title') | sanitizeHtml"></div>

                        <div
                            class="purchase__descr"
                            [innerHTML]="wts.getI18nLabel(i18nBasePath, 'description') | sanitizeHtml"></div>

                        <div class="payment-info">
                            <div class="payment-info__descr">
                                <ng-container *ngIf="data.numberAndStats?.stats; else skeleton">
                                    <p
                                        class="payment-info__subtext"
                                        [class.payment-info__subtext-warning]="showSharePickerError">
                                        <ng-container *ngIf="showSharePickerError; else minShares">
                                            {{ data.numberAndStats?.stats?.message }}
                                        </ng-container>
                                    </p>

                                    <ng-template #minShares>
                                        {{
                                            wts.getI18nLabel(i18nBasePath, 'shares.min', {
                                                min: data.numberAndStats?.stats?.numMinPurchaseAbleShares | i18nPlural : shareMapping
                                            })
                                        }}
                                        <br class="hide-tablet hide-desktop" />
                                        {{
                                            wts.getI18nLabel(i18nBasePath, 'shares.max', {
                                                max: data.numberAndStats?.stats?.canPurchase | i18nPlural : shareMapping
                                            })
                                        }}
                                    </ng-template>
                                </ng-container>
                            </div>
                        </div>

                        <div class="purchase-details__calc">
                            <app-calculator-form
                                [minNumber]="data.numberAndStats?.stats?.numMinPurchaseAbleShares"
                                [maxNumber]="data.numberAndStats?.stats?.canPurchase"
                                [pricePerShare]="data.item?.pricePerShareCents / 100"
                                (calcChange)="onCalcChange($event)"></app-calculator-form>
                        </div>

                        <div
                            class="purchase-details__kyc"
                            *ngIf="verification?.kycStatus === KycStatus.Disapproved">
                            <app-kyc-disapproved-alert (redirectCTAClicked)="onEditPersonalInfo()"></app-kyc-disapproved-alert>
                        </div>

                        <div class="purchase-details__personal">
                            <app-personal-info
                                [info]="verification?.personalInformation"
                                (editPersonalInfo)="onEditPersonalInfo()"></app-personal-info>
                        </div>
                    </div>

                    <div
                        nz-col
                        nzXs="12"
                        class="purchase__summary">
                        <ng-container *ngIf="data?.numberAndStats?.stats; else skeleton">
                            <app-summary
                                [entity]="cart$ | async"
                                [frequency]="frequency"
                                [purchaseStart]="purchaseStart$ | async"
                                [numberOfShares]="numberOfShares ?? 1"
                                [stats]="stats$ | async"
                                [withImage]="false"
                                *ngIf="
                                    !(
                                        (item?.schema?.regulationType === OFFERING_REGULATION_TYPES.RegD &&
                                            !wts.isAccreditedInvestor(initData)) ||
                                        (appAndItemSupportsRegCF(item) && wts.isForeignInvestor(initData))
                                    )
                                "></app-summary>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div
                nz-row
                nzGutter="30">
                <div
                    nz-col
                    nzXs="12"
                    class="purchase__info">
                    <div class="steps-action">
                        <button
                            class="btn-angle-right"
                            nz-button
                            nzSize="large"
                            nzType="primary"
                            type="submit"
                            [disabled]="showSharePickerError"
                            (click)="onNextButtonClick()"
                            [nzLoading]="loader.isLoading$ | async">
                            {{ wts.getI18nLabel(i18nBasePath, 'actions.next') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>

<ng-template #skeleton>
    <nz-skeleton [nzActive]="true"></nz-skeleton>
</ng-template>
